import { useSelector } from 'react-redux';

const Money = ({
  value,
  currency = null,
  symbol = null,
  currencyCode = null,
  convert = true,
  decimal = true,
  lowDecimals = false,
  showSymbol = true,
  symbolSize,
  lineThrough = false,
}) => {
  const currencies = useSelector((state) => state.currency);
  const currencyToShow = currency ? currency : currencies.selected;

  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  if (value === null || isNaN(value)) return;

  const valueInSelectedCurrency = convert ? value * currencyToShow?.exchangeRate : value;

  if (symbol === null) {
    symbol = currencyToShow?.symbol;
  }

  const integerPart = parseInt(valueInSelectedCurrency.toFixed(2));
  const decimalPart = valueInSelectedCurrency.toFixed(2).slice(-2);

  return (
    <div className={`money ${!decimal ? 'p-0' : ''}`}>
      <div className={`integer ${lineThrough ? 'text-decoration-line-through' : ''}`}>
        {valueInSelectedCurrency < 0 && '-'}
        {currencyCode !== null ? currencyCode + ' ' : null}
        {showSymbol ? (
          <span style={{ fontSize: symbolSize ? symbolSize : 'inherit', marginRight: '0.1rem' }}>
            {symbol}
          </span>
        ) : (
          ''
        )}
        {Math.abs(integerPart).toLocaleString()}
        {lowDecimals ? `.${decimalPart}` : ''}
      </div>
      {decimal ? <span className={`moneyCents ${lineThrough ? 'text-decoration-line-through' : ''}`}>{decimalPart}</span> : ''}
    </div>
  );
};

export default Money;
